// extracted by mini-css-extract-plugin
export var addButton = "_e3-0";
export var border = "_e3-8";
export var check = "_e3-h";
export var danger = "_e3-6";
export var dropdownContainer = "_e3-1";
export var editModalBody = "_e3-j";
export var footerContainer = "_e3-i";
export var fullWidth = "_e3-a";
export var hide = "_e3-9";
export var icon = "_e3-3";
export var input = "_e3-7";
export var inputFlex = "_e3-b";
export var inputWrapper = "_e3-c";
export var manualFocus = "_e3-5";
export var optionButton = "_e3-4";
export var pillWrapper = "_e3-e";
export var pointer = "_e3-2";
export var showOverflow = "_e3-f";
export var tagsFlex = "_e3-d";
export var xButton = "_e3-g";